import { IIrembogovBasicLabelKeyPair } from './irembogov-basic-label-keypair.model';

export interface IOrganizationWhiteLabel {
  id: string;
  organizationId: string;
  url: string;
  name: string;
  number: string;
  primaryColor: string;
  fontFamily: string;
  fontFamilyEmbedUrl: string;
  theme: string;
  logo: string;
  favicon: string;
  heroSectionImage: string;
  mainText: string;
  supportingText: string;
  displaySearchBar: boolean;
  displayCategoryTab: boolean;
  groupServiceByCategory: boolean;
  sortServicesBy: string;
  footerLogo: string;
  copyrightText: string;
  xUrl: string;
  linkedinUrl: string;
  facebookUrl: string;
  instagramUrl: string;
  supportCenterUrlText: string;
  supportCenterUrlLink: string;
  customUrlText: string;
  customUrlLink: string;
  status: EWhiteLabelStatus;
}

export enum EWhiteLabelStatus {
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED',
  PUBLISHED = 'PUBLISHED',
  SUSPENDED = 'SUSPENDED',
}

export enum EWhiteLabelServiceSortTypes {
  SERVICE_NAME_ASC = 'SERVICE_NAME_ASC',
  SERVICE_NAME_DESC = 'SERVICE_NAME_DESC',
  DATE_CREATED_ASC = 'DATE_CREATED_ASC',
  DATE_CREATED_DESC = 'DATE_CREATED_DESC',
}

export interface IWhiteLabelTheme {
  name: string;
  key: string;
  url: string;
}

export const availableWhiteLabelThemes: IWhiteLabelTheme[] = [
  {
    name: 'Default Theme',
    key: 'DEFAULT',
    url: 'https://placehold.co/300x378/transparent/transparent?text=Default',
  },
  {
    name: 'Theme 01',
    key: 'THEME_O1',
    url: 'https://placehold.co/300x378/transparent/transparent?text=Theme+01',
  },
  {
    name: 'Theme 02',
    key: 'THEME_O2',
    url: 'https://placehold.co/300x263/transparent/transparent?text=Theme+02',
  },
  {
    name: 'Theme 03',
    key: 'THEME_O3',
    url: 'https://placehold.co/300x434/transparent/transparent?text=Theme+03',
  },
  {
    name: 'Theme 04',
    key: 'THEME_O4',
    url: 'https://placehold.co/300x346/transparent/transparent?text=Theme+04',
  },
  {
    name: 'Theme 05',
    key: 'THEME_O5',
    url: 'https://placehold.co/300x449/transparent/transparent?text=Theme+05',
  },
  {
    name: 'Theme 06',
    key: 'THEME_O6',
    url: 'https://placehold.co/300x340/transparent/transparent?text=Theme+06',
  },
];

export const whiteLabelPalleteStepsConfig: IIrembogovBasicLabelKeyPair<number>[] =
  [
    { label: '25', key: 0.96 },
    { label: '50', key: 0.936 },
    { label: '100', key: 0.83 },
    { label: '200', key: 0.62 },
    { label: '300', key: 0.45 },
    { label: '400', key: 0.3 },
    { label: '500', key: 0.135 },
    { label: '600', key: 0 },
    { label: '700', key: -0.206 },
    { label: '800', key: -0.403 },
    { label: '900', key: -0.6 },
    { label: '950', key: -0.665 },
  ];

export const whiteLabelColorPalleteStepsMap = (): Record<string, number> => {
  const stepsMap: Record<string, number> = {};
  whiteLabelPalleteStepsConfig.forEach(
    (config: IIrembogovBasicLabelKeyPair<number>) => {
      stepsMap[config.label] = config.key;
    }
  );

  return stepsMap;
};
